import { Injectable } from '@angular/core';
import { HttpWebApiService } from '@sb-shared/services/http-web-api.service';
import { Observable } from 'rxjs';
import { HttpRequestSettings, apis, controllerTypes } from '@sb-shared/models/request-settings';
import { PersonalisationSettings } from '@sb-shared/models/personalisation-settings';
@Injectable({
  providedIn: 'root'
})
export class ProfilePersonalisationService {
  configUser: HttpRequestSettings = {
    api: apis.Core,
    controllerType: controllerTypes.User,
  };
  
  constructor(
    private http: HttpWebApiService,
    ) { }

  getPersonalisationSettings(personId: number): Observable<PersonalisationSettings> {
    return this.http.get('Personalisation/Settings/' + personId, this.configUser);
  }

  updatePersonalisationSettings(personId: number, videoBackgroundOptionId: number) : Observable<any> {
    return this.http.put('Personalisation/Settings/' + personId, { videoBackgroundOptionId: videoBackgroundOptionId }, this.configUser);
  }
}
